import { SyntheticEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../ApplicationState';
import { isCoTeacherGeneralUIEnabled } from '../BackendInterface';
import { Segment } from '../core/core';
import Notifications from '../components/Notifications';
import Profile from './Profile';
import ChangePassword from './ChangePassword';
import Subscription from './Subscription';
import MyCoTeacherMembershipsPage from '../MyCoTeacherMembershipsPage';
import styles from './AccountSettings.module.scss';
import utilityStyles from '../SCSS/common/utilityStyles.module.scss';
import segmentStyles from '../SCSS/Segment.module.scss';

const AccountSettings = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState(0);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const [coTeacherEnabled, setCoTeacherEnabled] = useState(false);

  const handleClick = (_: SyntheticEvent<HTMLButtonElement>, index: number) => {
    setActiveTab(index);
  };

  const tabLabels = coTeacherEnabled
    ? ['Profile', 'Change Password', 'Co-Teacher Memberships', 'Notifications', 'Subscription']
    : ['Profile', 'Change Password', 'Notifications', 'Subscription'];

  useEffect(() => {
    setActiveTab(0);
  }, [setActiveTab]);

  useEffect(() => {
    const districtId = userProfile?.district || '';
    const schoolId = userProfile?.schoolId || '';

    isCoTeacherGeneralUIEnabled(districtId, schoolId).then((enabled) => {
      setCoTeacherEnabled(enabled);
    });
  }, [userProfile?.district, userProfile?.schoolId]);

  return (
    <div className={`${styles.accountSettingsContainer} ${utilityStyles.clearfix}`}>
      <div className={utilityStyles.pageTitleGap} />
      <Segment className={utilityStyles.line}>
        <div className={`${segmentStyles.moduleTitle} vcenter`}>Account Settings</div>
      </Segment>
      <Segment className={utilityStyles.line}>
        <div className={styles.container}>
          <section className={styles.formLeft}>
            {activeTab === 0 && <Profile />}
            {activeTab === 1 && <ChangePassword />}
            {coTeacherEnabled && activeTab === 2 && <MyCoTeacherMembershipsPage showTitle={false} />}
            {activeTab === (coTeacherEnabled ? 3 : 2) && <Notifications />}
            {activeTab === (coTeacherEnabled ? 4 : 3) && <Subscription />}
          </section>
          <section className={styles.formRight}>
            {tabLabels.map((tabName, index) => {
              return (
                <div key={tabName} className={styles.menuItem}>
                  <button
                    role='tab'
                    className={activeTab === index ? styles.activeTab : ''}
                    onClick={(e) => handleClick(e, index)}
                  >
                    {tabName}
                  </button>
                </div>
              );
            })}
          </section>
        </div>
      </Segment>
    </div>
  );
};

export default AccountSettings;
